function truncateText(text, maxLength) {
  if (text?.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text;
}

function checkForILSPhoneNumber(phone) {
  // Israeli mobile phone regex (supports formats: 05X-XXXXXXX or 05XXXXXXXX)
  const israeliPhoneRegex = /^05[0-9][0-9]{7}$/;

  // Clean the number from any non-digits
  const cleanNumber = phone.replace(/\D/g, "");

  if (israeliPhoneRegex.test(cleanNumber)) {
    // Remove leading 0 and add 972 prefix
    const formattedNumber = cleanNumber.replace(/^0/, "");
    return formattedNumber;
  } else {
    // If the number is not valid, return null or handle as needed
    console.error("Invalid Israeli phone number format.");
    return null;
  }
}

function openWhatsAppWithMessage(phone, message) {
  const url = `https://wa.me/972${phone}/?text=${encodeURIComponent(message)};`;

  // Optionally log the attempt
  console.log("Attempting to open WhatsApp...");

  // Open WhatsApp
  window.open(url, "_blank");
}

function isOdd(number) {
  return number % 2 !== 0;
}

function formatPrice(price) {
  const myPrice = price < 0 ? price * -1 : price;
  if (Number.isInteger(myPrice)) {
    return myPrice.toLocaleString();
  } else {
    return parseFloat(myPrice.toFixed(2)).toLocaleString();
  }
}

function getQueryPayLoad(query, path) {
  if (path.includes("/")) {
    path = path.length > 2 ? path.split("/")[2] : path;
  }
  return {
    ...query,
    [path]: path,
  };
}

module.exports = {
  truncateText,
  formatPrice,
  getQueryPayLoad,
  isOdd,
  openWhatsAppWithMessage,
  checkForILSPhoneNumber,
};
